import { render, staticRenderFns } from "./season-form-page.vue?vue&type=template&id=5534f562&"
import script from "./season-form-page.vue?vue&type=script&lang=js&"
export * from "./season-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports